import React from 'react'

export default function TabMenuContentContainer ({ children, className }) {
  return (
    <div className={`tab-menu-content-container ${className}`}>
      {children}
    </div>
  )
}
